import _defineProperty from "@babel/runtime/helpers/defineProperty";
import i18next from 'i18next';
import { DEFAULT_NAMESPACE, DEFAULT_LANGUAGE } from "./constants";
import { defaultTranslations } from "./constants/defaultTranslations";
export var i18n = i18next.createInstance({
  keySeparator: '::',
  fallbackLng: DEFAULT_LANGUAGE,
  lng: DEFAULT_LANGUAGE,
  resources: _defineProperty({}, DEFAULT_LANGUAGE, _defineProperty({}, DEFAULT_NAMESPACE, defaultTranslations)),
  interpolation: {
    prefix: '{',
    suffix: '}',
    escapeValue: false // react already prevents xss
  },

  react: {
    useSuspense: false,
    bindI18n: 'added removed languageChanged',
    bindI18nStore: 'added removed'
  }
});

// Init right away
i18n.init();